module.exports = __webpack_public_path__ + "static/media/79.e00fa4c.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/79.wav
// module id = FCnE
// module chunks = 0